import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { ServicesPostData } from 'src/app/services/_components/services/services.component';
import { ApiDatatableResponse } from 'src/app/main/_models/api-datatable-response';

@Injectable({
	providedIn: 'root'
})
export class ServicesService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	calculate(s: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/calculate`, s);
	}

	datatable(data: ServicesPostData) {
		return this.http.post<ApiDatatableResponse>(`${this.config.getConfig("apiEndpoint")}/services/dt`, data);
	}

	upsert(s: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services`, s);
	}

	get(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/` + id);
	}

	getOriginal(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/original/` + id);
	}

	serviziEliminati() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/ambrogio_cancelled`);
	}

	eliminaServizioEliminato(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/ambrogio_cancelled/${id}`);
	}

	copy(id: number) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/copy`, { id: id });
	}

	makeReturn(id: number) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/return`, { id: id });
	}

	delete(id: number) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/delete`, { id: id });
	}

	pdf(id: number) {
		return this.http.post<Blob>(`${this.config.getConfig("apiEndpoint")}/document`, { tipo_documento: 'partner_servizio', output: "PDF", id: id }, { responseType: "blob" as "json" });
	}

	customerAcceptance(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "AC" });
	}

	customerConfirm(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "COCL" });
	}

	retake(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "RI" });
	}

	confirm(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "CO" });
	}

	confirmDispo(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "COD" });
	}

	deny(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "RIF" });
	}

	denyDispo(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "RIFD" });
	}

	takeInCharge(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "PC" });
	}

	negate(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/status`, { id: id, action: "NE" });
	}

	getCompatibleReturnTrip(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/` + id + "/pr");
	}

	accettaModifiche(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/editstatus`, { id: id, action: 'A'});
	}

	rifiutaModifiche(id: number) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/editstatus`, { id: id, action: 'R'});
	}

	updateNumOrdine(s: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/numordine`, s);
	}

	segnalaExtra(s: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/services/extra-signal`, s);
	}

}
